import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const ContractContextNavigation = ({ contractId = "CT-2024-001", contractTitle = "Master Service Agreement" }) => {
  const location = useLocation();

  const contextTabs = [
    { 
      path: '/contract-details', 
      label: 'Overview', 
      icon: 'FileText',
      description: 'Contract details and summary'
    },
    { 
      path: '/contract-editor', 
      label: 'Editor', 
      icon: 'Edit3',
      description: 'Edit contract terms and clauses'
    },
    { 
      path: '/milestone-management', 
      label: 'Milestones', 
      icon: 'Calendar',
      description: 'Track project milestones and deadlines'
    },
    { 
      path: '/document-management', 
      label: 'Documents', 
      icon: 'FolderOpen',
      description: 'Manage attachments and related files'
    },
  ];

  const isContractContext = contextTabs?.some(tab => tab?.path === location.pathname);

  if (!isContractContext) {
    return null;
  }

  return (
    <div className="bg-card border-b border-border shadow-legal">
      {/* Contract Context Header */}
      <div className="px-6 py-4 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-8 h-8 bg-muted rounded-md">
              <Icon name="FileText" size={16} className="text-muted-foreground" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">{contractTitle}</h2>
              <p className="text-sm text-muted-foreground font-mono">{contractId}</p>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-2 px-3 py-1 bg-success/10 text-success rounded-full">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span className="text-xs font-medium">Active</span>
            </div>
          </div>
        </div>
      </div>
      {/* Context Navigation Tabs */}
      <div className="px-6">
        <nav className="flex space-x-8 overflow-x-auto">
          {contextTabs?.map((tab) => (
            <Link
              key={tab?.path}
              to={tab?.path}
              className={`flex items-center space-x-2 py-4 border-b-2 transition-legal-fast whitespace-nowrap ${
                location.pathname === tab?.path
                  ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              }`}
              title={tab?.description}
            >
              <Icon name={tab?.icon} size={16} />
              <span className="text-sm font-medium">{tab?.label}</span>
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default ContractContextNavigation;